// notify 는 성공·실패 피드백을 토스트로 알린다 (모달 유지 대신 — 모달 UX 관행).
// UIkit 이 아직 안 실렸으면 토스트를 못 띄우므로 콘솔에라도 남긴다 — 조용히 사라지면
// 실패를 표면화하려던 호출부의 의도가 무효가 된다.
export function notify(message, status) {
  if (window.UIkit && window.UIkit.notification) {
    window.UIkit.notification({ message, status, pos: 'top-center', timeout: 3000 })
    return
  }
  console.error('notify 실패 (UIkit 없음):', status, message)
}
